import { KeyboardEvent } from 'react';

export const preventDefaultBehaviourEnter = (event: KeyboardEvent<HTMLFormElement>) => {
  if (event.code === 'Enter' || event.code === 'NumpadEnter') {
    if (!(event.target instanceof HTMLTextAreaElement || event.target instanceof HTMLButtonElement)) {
      event.preventDefault();
    }
  }
};
